module.exports = __webpack_public_path__ + "static/img/card_3_2.14fe81a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en/card_3_2.png
// module id = 0Snn
// module chunks = 0